import {
  useQueryWithSimpleErrorHandling as useQueryWithErrorHandling,
  useClientQueryWithSimpleErrorHandling as useClientQueryWithErrorHandling,
  useSimpleError as useError
} from '@ts-private/apollo-tools-ts';
import { useToast } from '../toasts/useToast';

export const useSimpleError = () => {
  const addToast = useToast();
  const showError = useError((message, type, correlationId) => addToast(message, type, { correlationId }));
  return showError;
};

export const useQueryWithSimpleErrorHandling = (query, options = {}) => {
  return useQueryWithErrorHandling(query, options, useSimpleError);
};

export const useClientQueryWithSimpleErrorHandling = () => {
  return useClientQueryWithErrorHandling(useSimpleError);
};
